<!--
 * @Descripttion: 
 * @Author: lijingjing56
 * @Date: 2024-08-09 13:59:22
 * @LastEditors: lijingjing56
 * @LastEditTime: 2024-11-27 14:10:16
-->
<template>
    <div :class="['button-container', text != '立即咨询' && 'blueBtn']" @click="handleClick">
        <span style="display: inline-flex;align-items: center;">
            <span class="btn-two-text">{{text}}</span>
        </span>
    </div>
</template>

<script>
export default {
  name: "cloudButton",
  props: {
    text: {
      type: String,
      default: "立即查看"
    },
    handleClick: {
      type: Function,
      default: () => {}
    },
    iconDirection: {
      type: String,
      default: () => "right"
    }
  }
};
</script>

<style lang="scss" scoped>
.button-container {
  height: 38px;
  line-height: 40px;
  width: 136px;
  text-align: center;
  background: transparent;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #000;

  .btn-two-text {
    font-size: 16px;
    color: #000;
  }

  .btn-two-line {
    width: 1px;
    height: 25px;
    background-color: #d11005;
  }

  .btn-two-icon {
    display: inline-block;
    width: 7px;
    height: 6px;
    margin-left: 14px;
    margin-right: 14px;
  }
}
  .btn-two-line-left {
    background-color: #d8d8d8;
  }

  .btn-two-text-left {
    color: #d8d8d8;
    font-size: 12px;
    font-weight: 600;
  }

.blueBtn {
  background: #3247FF;
  border: 1px solid #3247FF;
  .btn-two-text {
    font-size: 16px;
    color: #fff;
  }
}

</style>

